import { Sprite } from "pixi.js";
import { GameAssets } from "./shared/util/GameAssets";
import gsap from "gsap";
import MathUtils from "./shared/util/MathUtils";

export class MultiplierParticle {
    private _sprites: Sprite[];
    public get sprites(): Sprite[] {
        return this._sprites;
    }

    private readonly SPEED: number = 500;
    private readonly SPRITE_COUNT: number = 5;

    constructor(position: { x: number, y: number }) {
        this._sprites = Array.from({ length: this.SPRITE_COUNT }, () => new Sprite(GameAssets.textures.glowParticle));

        this._sprites.forEach(sprite => {
            // Add random deviation (-20 to +20 pixels)
            const randomX = position.x + (Math.random() - 0.5) * 60;
            const randomY = position.y + (Math.random() - 0.5) * 60;

            sprite.anchor.set(0.5);
            sprite.position.set(randomX, randomY);
        });
    }

    public moveTo(position: { x: number, y: number }, moveDuration: number, onComplete: () => void): void {
        let completedCount = 0;

        this.sprites.forEach(sprite => {
            const randomDelay = Math.random() * 0.1;;

            const duration: number = moveDuration;
            const masterTimeline = gsap.timeline({ delay: randomDelay });
            const scaleProxy = { value: 0 };

            masterTimeline
                .to(
                    sprite.position, {
                    x: position.x,
                    y: position.y,
                    duration: duration,
                    onComplete: () => {
                        completedCount++;
                        if (completedCount === this.SPRITE_COUNT) {
                            onComplete();
                        }
                    }
                }, 0)

                .fromTo(sprite, { alpha: 0 }, {
                    alpha: 1,
                    duration: duration * 0.4,
                    ease: "power2.out"
                }, 0)
                .to(sprite, {
                    alpha: 0,
                    duration: duration * 0.6,
                    ease: "power2.in"
                }, duration * 0.4)

                .fromTo(scaleProxy, { value: 0 }, {
                    value: 2,
                    duration: duration * 0.2,
                    ease: "power2.out",
                    onUpdate: () => {
                        // console.log('Scale up:', scaleProxy.value);
                        sprite.scale.set(scaleProxy.value);
                    }
                }, 0)
                .to(scaleProxy, {
                    value: 1,
                    duration: duration * 0.4,
                    ease: "power2.in",
                    onUpdate: () => {
                        // console.log('Scale down:', scaleProxy.value);
                        sprite.scale.set(scaleProxy.value);
                    }
                }, duration * 0.2);
        });
    }

    public stopAndClear(): void {
        this._sprites.forEach(sprite => {
            gsap.killTweensOf(sprite);
            gsap.killTweensOf(sprite.position);

            if (sprite.parent) {
                sprite.parent.removeChild(sprite);
            }

            sprite.destroy();
        });

        this._sprites = [];
    }
}
